/*
 *@Description: 布控管理-表格列配置
 *@Author: zhengff
 *@Date: 2019-04-26 21:55:36
 */
import { Dic, Bus, Dates } from '$utils'
import i18n from '@src/common/lib/i18n'
export const tableColumn = () => {
    return [{
            label: i18n.t('carPatrolBlack.label.number'),
            prop: 'plateCode',
            viewDisplay: true,
            overHidden: true,
        },
        {
            label: i18n.t('carPatrolBlack.label.owner'),
            prop: 'ownerName',
            viewDisplay: true,
            // width:100,
            align: 'center',
        },
        {
            label: i18n.t('carPatrolBlack.label.type'),
            prop: 'vehicleType',
            align: 'center',
            viewDisplay: true,
            formatter: function(row, value) {
                return Dic.findByValue('SENU038', value)
            },
            viewFormatter: function(row, value) {
                return Dic.findByValue('SENU038', value)
            },
        },
        {
            label: i18n.t('carPatrolBlack.label.color'),
            prop: 'vehicleColor',
            viewDisplay: true,
            formatter: function(row, value) {
                return Dic.findByValue('SENU039', value)
            },
            viewFormatter: function(row, value) {
                return Dic.findByValue('SENU039', value)
            },
        },
        {
            label: '车辆品牌',
            prop: 'vehicleBrand',
            viewDisplay: true,
            hide: true,
            formatter: function(row, value) {
                return Dic.findByValue('SENU042', value)
            },
            viewFormatter: function(row, value) {
                return Dic.findByValue('SENU042', value)
            },
        },
        {
            label: '是否特定车辆',
            prop: 'isSpecial',
            viewDisplay: true,
            hide: true,
            viewFormatter: (row, value) => {
                if (Number(value) === 0) {
                    return '否'
                } else if (Number(value) === 1) {
                    return '是'
                }
                return '';
            },
        },
        {
            label: i18n.t('carPatrolBlack.label.remark'),
            prop: 'desc',
            viewDisplay: true,
            span: 24,
            width: 100,
            align: 'center',
        },
        {
            label: i18n.t('carPatrolBlack.label.picture'),
            prop: 'img',
            viewDisplay: true,
            viewslot: true,
            span: 24,
            width: 100,
            align: 'center',
        },
    ]
}